import {Flex, Heading, Label} from "@aws-amplify/ui-react";
import EiaTitle from "../../components/EiaTitle";
import EiaFixedTable from "../../components/tables/EiaFixedTable";
import React from "react";
import {
    abhorrentHeart,
    betrayersHusk,
    distilledFear,
    exquisiteBlood,
    judicatorsMask,
    livingSteel,
    malignantHeart,
    pincushionedDoll,
    shardOfAgony,
    stygianStone
} from "../../commons/wowhead/D4ItemLinks";
import {runesLink, uniquesLink} from "../../commons/wowhead/D4Uniques";
import Utils from "../../commons/Utils/Utils";
import EiaCard from "../../components/cards/EiaCard";
import EiaImage from "../../components/EiaImage";
import d4season8bossladder from '../../resources/diablo-4-season-8-lair-boss-ladder.jpg'

const separator = ",\u00A0";
const createArrayWithKeys = function (items) {
    return <Flex direction={"row"} gap={"0rem"}>
        {
            items.map((value, index) => <div key={index}>{value}</div>)
        }
    </Flex>

}

const isSmallScreen = Utils.isSmallScreen();
const tableEntryFlexDirection = isSmallScreen ? "column" : "row"

const bossTableHeader = ["Tier", "Lair Boss", "Lair boss keys to open hoard", "Drops"];
const bossData = [
    ["Initiate", "Grigoire", livingSteel(12),
        createArrayWithKeys([uniquesLink,separator, betrayersHusk(), separator, shardOfAgony(), separator, runesLink, separator, stygianStone(), separator, "Crafting Materials, Gold"])],
    ["Initiate", "Varshan", malignantHeart(12),
        createArrayWithKeys([uniquesLink, separator, betrayersHusk(), separator, shardOfAgony(), separator, runesLink, separator, stygianStone(), separator, "Crafting"
        + " Materials, Gold"])],
    ["Initiate", "Beast in Ice", distilledFear(12),
        createArrayWithKeys([uniquesLink, separator, betrayersHusk(), separator, pincushionedDoll(), separator, runesLink, separator, stygianStone(), separator, "Crafting"
        + " Materials, Gold"])],
    ["Initiate", "Zir", exquisiteBlood(12),
        createArrayWithKeys([uniquesLink, separator, betrayersHusk(), separator, pincushionedDoll(), separator, runesLink, separator, stygianStone(), separator,"Crafting"
        + " Materials, Gold"])],

    ["Initiate", "Urivar", judicatorsMask(12),
        createArrayWithKeys([uniquesLink, separator, betrayersHusk(), separator, abhorrentHeart(), separator, runesLink, separator, stygianStone(), separator, "Crafting"
        + " Materials, Gold"])],

    ["Greater", "Andariel", pincushionedDoll(3), createArrayWithKeys([uniquesLink, separator, betrayersHusk(), separator, runesLink, separator, "Crafting Materials, Gold"])],
    ["Greater", "Duriel", shardOfAgony(3), createArrayWithKeys([uniquesLink, separator, betrayersHusk(), separator, runesLink, separator, "Crafting Materials, Gold"])],
    ["Greater", "Harbinger of Hatred", abhorrentHeart(3), createArrayWithKeys([uniquesLink, separator, betrayersHusk(), separator, runesLink, ", Crafting Materials, Gold"])],

    ["Exalted", "Belial", betrayersHusk(2), createArrayWithKeys([uniquesLink, separator, runesLink, ", Crafting Materials, Gold"])],
];

const BossSummoning = function () {

    return <Flex direction={"column"}>
        <EiaTitle title={"Boss Summoning (Season 10)"} lastUpdated={"2025/09/23"}/>
        <EiaCard variation={"outlined"} roundCorners={true}>
            <Label>
                <Flex direction={"column"} gap={"0rem"}>
                    {
                        [
                            ["\u2022 You must be on Torment Difficulty I or higher to fight any Lair Boss."],
                            ["\u2022 The first Unique item dropped by a Lair Boss will be from their unique pool. Further Unique Items will have a 50% chance to be from the general Unique pool. In Torment Difficulty III, an additional guaranteed Unique item from the item pool will drop."],
                            ["\u2022 When playing in a party, Lair Bosses have a 33% chance per additional party member to drop an extra Unique Item from their unique pool."],
                            ["\u2022 Each boss requires specific lair boss keys to open their Hoard."],
                        ].map(((listingPoint, index) => {
                            return <Label key={index}>{listingPoint}</Label>
                        }))
                    }
                </Flex>
            </Label>
        </EiaCard>
        <Flex direction={"row"} justifyContent={"center"}>
            <EiaCard>
                <EiaImage objectFit="cover" height={400} src={d4season8bossladder} tealBorder={true}/>
            </EiaCard>
        </Flex>
        <Heading level={6}>Lair Boss Table</Heading>
        <EiaFixedTable data={bossData} tableHeader={bossTableHeader}/>
    </Flex>
}

export default BossSummoning;